import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

import { $api } from "../../../../../../helpers/$api";
import { Util } from "../../../../../../helpers/util";
import "./ReferralWithdraw.css";

const ReferralWithdraw = ({ pendingEarnings }) => {
  const [banks, setBanks] = useState([]);
  const [payload, setPayload] = useState({ amount: "", bank_id: "" });
  const [isLoading, setLoading] = useState(false);

  const handleInput = (event) => {
    const { value, name } = event.target;
    console.log(typeof value);
    if (name === "amount" && isNaN(+value)) return;

    setPayload((i) => ({ ...i, [name]: value }));
  };

  const handleSubmit = async () => {
    const { amount, bank_id } = payload;
    if (!amount || amount > pendingEarnings || !bank_id || isLoading) return;

    try {
      setLoading(true);
      await $api.user.withdrawReferralEarnings(payload);
      toast.success("Withdrawal successful");
      setPayload({ amount: "", bank_id: "" });
    } catch (error) {
      toast.error(`Error withdrawing: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const banks = await $api.user.getBanks();

        setBanks(
          banks.sort((a, b) =>
            a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1
          )
        );
      } catch (error) {
        // error getting banks
      }
    })();
  }, [setBanks]);

  const { currency } = Util.getCurrency();

  return (
    <div className="withdraw-page">
      <div className="withdraw-text">
        <p>Withdraw Referral Bonus</p>
      </div>
      <div className="withdraw">
        <input
          type="text"
          className="withdraw-input"
          placeholder="Enter amount"
          name="amount"
          onChange={handleInput}
          value={payload.amount}
        />
        <p>
          Available balance: {currency}{" "}
          {Util.formatMoneyNumber(pendingEarnings)}
        </p>
      </div>
      <div>
        <select
          name="bank_id"
          onChange={handleInput}
          value={payload.bank_id}
          className="select-bank"
        >
          <option value="">{"Select Bank"}</option>

          {banks.map((bank) => {
            return (
              <option value={bank.id} key={bank.id}>
                {bank.name}
              </option>
            );
          })}
        </select>
      </div>
      <button className="withdraw-button1" onClick={handleSubmit}>
        Withdraw
      </button>
    </div>
  );
};

export default ReferralWithdraw;
